import _ from '../../../utils/lodash';

export const mapOrgUnitOptions = (response, hasAny) => {
  const mappedResult = [{ id: 0, name: 'Any' }];
  if (response === null || response.options === null) return hasAny ? mappedResult : [];

  return hasAny ? _.concat(mappedResult, response.options) : response.options;
};
